var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"get-started-link",attrs:{"to":{
    name: 'property-sites-create',
    params: { propertyId: _vm.id },
  }}},[_c('div',[_c('v-icon',{attrs:{"large":"","color":"primary"}},[_vm._v("mdi-map-marker-plus")]),_c('div',{staticClass:"h4 mt-2 mb-2 primary--text"},[_vm._v(" Create a site ")]),_c('div',{staticClass:"text--small grey--text"},[_vm._v(" Get started by creating your first survey site. This is where you set a camera-trap ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }